import { render, staticRenderFns } from "./btnS.vue?vue&type=template&id=7a3b7288&scoped=true&"
import script from "./btnS.vue?vue&type=script&lang=js&"
export * from "./btnS.vue?vue&type=script&lang=js&"
import style0 from "./btnS.vue?vue&type=style&index=0&id=7a3b7288&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3b7288",
  null
  
)

export default component.exports